
































import {Component, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import DeviceApi from "@/module/device/DeviceApi";
import Topic from "@/module/device/Topic";
import deviceModule from "@/store/module/DeviceModule";
import RefreshButton from "@/component/Button/refresh-button.vue";

@Component({
  components: {
    RefreshButton,
  },
})
export default class DeviceTopicView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private topic = new Topic()

  private leftColSpan = 2
  private rightColSpan = 10

  private async created() {
    await this.getTopics()
  }

  private refresh() {
    this.getTopics()
  }

  private async getTopics() {
    this.topic = await this.deviceApi.topics(deviceModule.active.id)
  }
}
